import {isArray} from 'lodash-es';


export const traverse = (object: any, compareFn: (key: any, value: any) => boolean, processFn: (val: any) => any, debug = false) => {
  if (object === null || object === undefined || typeof object !== 'object') {
    return object;
  }
  if (isArray(object)) {
    object.forEach(obj => traverse(obj, compareFn, processFn));
  }
  for (const key of Object.keys(object)) {
    const value = object[key];
    if (debug){
      console.log(key, value);
    }
    if (compareFn(key, value)) {
      object[key] = processFn(value);
    } else if (typeof value === 'object') {
      traverse(value, compareFn, processFn);
    }
  }
  return object;
}

